import setIn from 'transmute/setIn';
import { SEEN, VID, VISITOR } from './threadListMemberKeyPaths';
export const setSeen = setIn(SEEN);
export const setVid = setIn(VID);
export const setVisitor = setIn(VISITOR);